








import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class ThreePanelConditionCategoryItemAction extends Vue {
  @Prop()
  selectedBrands: any[];

  @Prop()
  brandSelectAllIndex: any[];

  @Prop()
  item: any;

  @Prop()
  prefix: string;

  @Prop({default: true})  
  noEvents: boolean; 

  @Emit('toggle')
  onToggle(item: any) {}

  pSelectedBrands: any[] = [];
  pBrandSelectAllIndex: any[] = [];

  data() {
    return {
      pSelectedBrands: this.selectedBrands,
      pBrandSelectAllIndex: this.brandSelectAllIndex
    }
  }

  mounted() {
    if(!this.noEvents) {
      this.bus.on(this.prefix + '-selected-brands', this.onBusSelectedBrands);
      this.bus.on(this.prefix + '-brand-select-all-index', this.onBusBrandSelectAllIndex);
    }
  }

  beforeDestroy() {
    if(!this.noEvents) {
      this.bus.off(this.prefix + '-selected-brands', this.onBusSelectedBrands);
      this.bus.off(this.prefix + '-brand-select-all-index', this.onBusBrandSelectAllIndex);
    }
  }

  onBusSelectedBrands(selectedBrands: any[]) {
    this.pSelectedBrands = selectedBrands;
  }

  onBusBrandSelectAllIndex(brandSelectAllIndex: any[]) {
    this.pBrandSelectAllIndex = brandSelectAllIndex;
  }

   get isPickedAll() {
     return this.pBrandSelectAllIndex[this.item.name];
   }

  get isBrandSelected() {
    return this.pSelectedBrands.indexOf(this.item.name) !== -1;
  }
}
